<!--
 * @Author: huanglin.like@qq.com
 * @LastEditTime: 2023-12-01 16:49:12
-->
<template>
  <div>
    <com-search :columns="columns" @search="handleSearch">
      <template #storeCode="{ data }">
        <el-select
          v-model="data.searchValues[data.item.prop]"
          filterable
          remote
          clearable
          placeholder="请输入关键词"
          :remote-method="remoteMethod"
          :loading="loading"
        >
          <el-option
            v-for="item in data.item.option"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </template>
    </com-search>
  </div>
</template>

<script>
import { allSiteList } from '@/api/site'

export default {
  props: {
    typeOfView: {
      type: String,
      default: ''
    }
  },
  watch: {
    typeOfView: {
      handler(val) {
        // 用户充值订单视图
        if (val === 'user') {
          this.columns.splice(0, 1)
          this.columns.splice(2, 1)
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      columns: [
        {
          label: '用户ID/手机号',
          prop: 'userCondition',
          type: 'input'
        },
        {
          label: '订单编号',
          prop: 'number',
          type: 'input'
        },
        {
          label: '电卡号',
          prop: 'cardNo',
          type: 'input'
        },
        {
          label: '充值时间',
          prop: 'date',
          type: 'date'
        },
        {
          label: '状态',
          prop: 'status',
          type: 'select',
          option: [
            {
              label: '未支付',
              value: '1'
            },
            {
              label: '已支付',
              value: '2'
            }
          ]
        },
        {
          label: '网点',
          prop: 'storeCode',
          type: 'slot',
          slotName: 'storeCode',
          option: []
        }
      ],
      loading: false
    }
  },
  methods: {
    handleSearch(val) {
      this.$emit('search', val)
    },

    remoteMethod(query) {
      console.log('object :>> ', query)
      this.getSiteList(query)
    },

    async getSiteList(name) {
      this.loading = true
      const {
        data: { records }
      } = await allSiteList(name)
      this.columns.at(-1).option = records.map((item) => {
        return {
          label: item.name,
          value: item.code
        }
      })
      this.loading = false
      console.log('网点列表 :>> ', records)
    }
  }
}
</script>
